<template>
  <!-- tree starts -->
  <ul :class="'tmf-tree-anchor ps-0' + patid" v-for="elem in list" :key="elem.id">
    <li>       
      <div class="d-flex">
         
        <label
        @click.prevent="getFolderChildren(elem.id, {elem: elem.type})"
          class="tmf-folder-label " :id="`etmf-`+ elem.id"
          :class="currentselectedfolder == elem.id ? 'tmf-tree-label tmf-bold-font' : 'tmf-tree-label'"          
          ><span class="d-flex align-items-center mr-2" ><p v-if="elem.typeId" class="px-1 mb-0">{{ elem.typeId ?  elem.typeId :''}}</p>{{ elem.name }}</span>   
        </label>                          
        <button v-if="showSideButton==true" class="tmf-ellipsis-btn border-0 bg-transparent cursor-pointer px-3 py-1"
          @click="openSidePopup(elem)"
          :popovertarget="`tmf-`+ elem.id"
          :anchor="`tmf-`+ elem.id"
        >
            <i class="fa fa-ellipsis-v"></i>
        </button>  
      </div>
      <div 
        :id="`tmf-`+ elem.id" popover class="tmf-popup-menu">
          <div class="text-center p-2 w-100" v-if="showFolderLoading[elem.id]"><img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" /></div>
          <template v-else>
            <div class="pointer-none px-2 py-3" v-if="anyuserpermissions==false">Nothing to show</div> 
             <button  v-if="this.userpermissions.includes('Add')" class="popup-menu-block text-start" @click="folderFunctionality('add',`tmf-`+ elem.id,elem.id)">Add</button>
              <button  v-if="this.userpermissions.includes('Archive')" class="popup-menu-block text-start" @click="folderFunctionality('archive',`tmf-`+ elem.id)">Archive</button>
              <button  v-if="this.userpermissions.includes('Clone')" class="popup-menu-block text-start" @click="folderFunctionality('clone',`tmf-`+ elem.id,elem.name)">Clone</button>
              <button  v-if="this.userpermissions.includes('Delete')" class="popup-menu-block text-start" @click="folderFunctionality('delete',`tmf-`+ elem.id,elem.ancestorIds)">Delete</button>             
              <button  v-if="this.userpermissions.includes('Download')" class="popup-menu-block text-start" @click="folderFunctionality('export',`tmf-`+ elem.id,elem.name)">Download</button>
              <button  v-if="elem.type=='Root' && this.userpermissions.includes('Folder Structure Export')" class="popup-menu-block text-start" @click="folderFunctionality('exportFolderTreeStructure',`tmf-`+ elem.id,elem.name)">Export Folder Tree Structure</button>
              <button  v-if="this.userpermissions.includes('Edit')" class="popup-menu-block text-start" @click="folderFunctionality('edit',`tmf-`+ elem.id)">Edit</button> 
              <button  v-if="this.userpermissions.includes('Permissions')" class="popup-menu-block text-start" @click="folderFunctionality('permission',`tmf-`+ elem.id,'file')">Permission</button>
              <button  v-if="this.userpermissions.includes('Share')" class="popup-menu-block text-start" @click="folderFunctionality('share',`tmf-`+ elem.id,elem)">Share</button>             
              <button  v-if="this.userpermissions.includes('Upload')" class="popup-menu-block text-start" @click="folderFunctionality('upload',`tmf-`+ elem.id,'file')">Upload</button>
            
          </template>
        
       </div>  
      <div v-if="showTreeLoader[elem.id]==true && folderswitch[elem.id]==true">
        <img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" />
      </div>
      <div v-else> 
        <TreeWithNewpopup
    class="modify-block"
    v-if="folderswitch[elem.id]"
    :restoreOnMount="restorePhase"  
    :showLoader="showTreeLoader[elem.id]"
    :parentfolderlist="alreadyOpened"
    :patid="elem.id"
    @editFolder="handleInnerFunc('edit')"
    @addFolder="handleInnerFunc('add',$event)"
    @deleteFolder="handleInnerFunc('delete',$event)"
    @archiveFolder="handleInnerFunc('archive')"
    @cloneFolder="handleInnerFunc('clone',$event)"
    @exportFolder="handleInnerFunc('export',$event)"
    @addFolderPermission="handleInnerFunc('permission',$event)"
    @shareFolderPermission="handleInnerFunc('share',$event)"
    @uploadDocument="handleInnerFunc('upload',$event)"
    @emptyChild="handleInnerFunc('emptyChild',$event)"
    @folderType="handleInnerFunc('folderType',$event)"
    :list="foldertreelist[elem.id]"
    :boldfolder="boldfolder"
  />
      </div>
    </li>  
  </ul>
</template>

<script src="./TreeWithNewpopup.js"></script>

<style  scoped>

.tmf-tree-label{
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding: 0.3em 0.5em;
  position:relative;
  margin-bottom: 0;
}
.tmf-tree-label:hover{
  background-color:#f0f0f0;
  cursor:pointer;
}
.tmf-tree-label:before{
  color: #fff;
  position: relative;
  z-index: 1;
  float: left;
  margin: 0 0.5em 0 -2em;
  width: 1em;
  height: 1em;
  border-radius: 1em;
  content: url("../../assets/images/folder-close.png");
  text-align: center;
  line-height: .8em;
}
.myStyle {
  color: blue;
}
.tmfshowHide {
  display: block;
}
.tmf-bold-font {
  font-weight:bold;
}
span ul li:hover .more-option-icon {
  display: block;
}
.selected {
  display: none ;
}
/* CSS Popover Styles */

.tmf-ellipsis-btn{
    anchor-name:--manage-btn;
    border:0;
  }
  .tmf-popup-menu {
    position:absolute;
    inset: auto;
    text-align: left;
    border-radius: 5px;
    border: 1px solid #e7eaec;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
    z-index: 200;
  }
  .tmf-popup-menu{
    top:anchor(bottom);
    right:anchor(left);
    width: fit-content;       
    min-width: 160px;  
    margin-inline-end: 5px;
  }
  .tmf-popup-menu{
    position-try-fallbacks: --bottom;
    top:anchor(bottom);
    right:anchor(right);
    width: fit-content;       
    min-width: 160px;    
  }
  .tmf-popup-menu> button{
    width:100%;
    border:0;
    font-size:0.8rem;
    font-weight:400;
    color:rgba(0,0,0);
    padding: 0.5rem 0.8rem;
  }

  [popover]:popover-open {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    animation: fadeIn 0.2s ease-in-out;
  }

  .tmf-popup-menu> .popup-menu-block:hover, .popup-submenu> div:hover{
    background-color: #e4eaf9;
  }

  @position-try --bottom{
    inset:auto;
    bottom:anchor(top);
    right:anchor(left)
  }

/* CSS Popover Styles */
</style>
